<template>
  <div class="d-flex flex-column col-12">
    <div class="d-flex flex-column align-items-center about-us-container col-12">
      <img class="col-7 mt-2 pop-in" src="../../assets/mobile/logo-sml.png">
      <div class="d-flex flex-column text-center mt-2 about-us-header">About Us</div>
      <div class="d-flex flex-column align-items-center text-center mt-2 about-us-text col-12">
        <div class="col-10">
          We are an indie game studio based in South
          Africa, started by a group of like-minded creatives. At Lunar Loop Games, we weave thrilling experiences from
          the darkest threads of horror, mystery, and suspense. Our signature comic book art style, marked by bold,
          unapologetic lines, sets the tone for unforgettable gaming experiences.
        </div>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center mt-2 mb-2 our-games-text">Our Games</div>
    <div class="d-flex flex-column game-container"
         :style="{ backgroundImage: `url(${require(`../../assets/mobile/${2}.png`)})` }">
      <div class="d-flex flex-column col-12">
        <div class="d-flex flex-column align-items-center text-center mt-3 col-12 game-header">
          <div class="col-6">ZOmbotomy</div>
        </div>
        <div class="d-flex flex-column align-items-center game-text col-12 slide-element-left-to-right">
          <div class="col-10">
            In this spooky adventure, you control a mischievous zombie head that’s ready to take over the undead. Your
            mission is as bizarre as it sounds: launch your detached head from its body, ricochet off haunted
            gravestones, and land it perfectly on another zombie to seize their body! Step into a world where mischief
            meets the macabre, and every toss is a step closer to becoming the ultimate undead prankster. Prepare for
            endless entertainment with just the right amount of ghostly charm!
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column game-container mt-2"
         :style="{ backgroundImage: `url(${require(`../../assets/mobile/${3}.png`)})` }">
      <div class="d-flex flex-column col-12">
        <div class="d-flex flex-column align-items-center text-center mt-3 col-12 game-header">
          <div class="col-6">Echo’s Past</div>
        </div>
        <div class="d-flex flex-column align-items-center game-text col-12 slide-element-left-to-right">
          <div class="col-10">
            Step into the spectral shoes of Echo, a curious ghost lost within the twisting corridors of the
            mysterious Hallow’s Hall Mansion. In this puzzle-adventure, your mission is to navigate the halls of this
            haunted estate. Can you guide Echo out of the never-ending maze of haunted rooms? Only the cleverest spirits
            will make it far.
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column game-container mt-2"
         :style="{ backgroundImage: `url(${require(`../../assets/mobile/${4}.png`)})` }">
      <div class="d-flex flex-column col-12">
        <div class="d-flex flex-column align-items-center text-center mt-3 col-12 game-header">
          <div class="col-6">Razor strike</div>
        </div>
        <div class="d-flex flex-column align-items-center game-text col-12 slide-element-left-to-right">
          <div class="col-10">
            Hell has never seen anything like Saw Girl. In this thrill ride, you take control of a fierce heroine riding
            the unstoppable Motorsaw—a giant, spinning blade that defies gravity, scales walls, and carves a path
            straight through chaos. Your mission? Tear through grotesque enemies, avoid deadly traps, and rocket your
            way up the fiery towers of the underworld with razor-sharp reflexes and relentless speed.
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column game-container mt-2"
         :style="{ backgroundImage: `url(${require(`../../assets/mobile/${5}.png`)})` }">
      <div class="d-flex flex-column col-12">
        <div class="d-flex flex-column align-items-center text-center mt-3 col-12 game-header">
          <div class="col-6">Shadow Hunt</div>
        </div>
        <div class="d-flex flex-column align-items-center game-text col-12 slide-element-left-to-right">
          <div class="col-10">
            You find yourself trapped deep beneath the surface in the Shadow Dungeon, your only companion is the dim
            flicker of your torch—and the unsettling whispers of what lurks beyond its glow. In Shadow Hunt, you must
            survive the creeping dread of the dark, using your torch light as your only weapon against the cold,
            drifting horrors that haunt these halls.
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column game-container mt-2"
         :style="{ backgroundImage: `url(${require(`../../assets/mobile/${6}.png`)})` }">
      <div class="d-flex flex-column col-12">
        <div class="d-flex flex-column align-items-center text-center mt-3 col-12 game-header">
          <div class="col-6">Last Breath</div>
        </div>
        <div class="d-flex flex-column align-items-center game-text col-12 slide-element-left-to-right">
          <div class="col-10">
            Plunge into the chilling depths of the unknown in Last Breath, a thrilling underwater adventure where every
            second counts. You play as a lone diver trapped far below the ocean’s surface with only one goal—make it out
            alive before your oxygen runs dry. Swim upward through the dark, dodge lurking sea creatures, and weave
            through eerie underwater obstacles. Will you reach the surface—or become just another mystery lost to the
            deep?
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center">
      <div class="mt-4 ready-play-text">Ready to start Playing?</div>
      <div class="game-zar-text"> All our games are now available on GameZAR</div>
      <div @click="playNowClicked" class="d-flex flex-column justify-content-center play-now-btn mt-4 mb-4">
        Play Now
      </div>
    </div>
    <div class="d-flex flex-column footer">
      <div class="d-flex flex-column align-items-center col-12 mt-3">
        <div class="d-flex flex-column align-items-center col-8">
          <div class="get-in-touch">Get In Touch</div>
          <div class="footer-email">lunarloops@gmail.com</div>
        </div>
        <div class="d-flex flex-column align-items-start col-8 mt-4">
          <div class="footer-header">Lunar Loops Games</div>
          <div class="footer-info">Proudly Based in South Africa</div>
        </div>
        <div class="d-flex flex-column align-items-start col-8 mt-4">
          <div class="footer-header">Legal</div>
          <div class="footer-info">Terms of Service</div>
        </div>
        <div class="copyright-text mt-3 mb-4">Copyright @ 2025 Lunar Loops Games. All rights
          reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DesktopHome",
  methods: {
    playNowClicked() {
      window.open("https://gamezar.co.za");
    },
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('slide-in-active');
            observer.unobserve(entry.target);
          }
        });
      }, options);

      document.querySelectorAll('.slide-element-left-to-right').forEach(element => {
        observer.observe(element);
      });
    }
  },
  mounted() {
    this.setupIntersectionObserver();
  },
}

</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.pop-in {
  animation: fadeIn 1.4s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.slide-element-left-to-right {
  opacity: 0;
  transform: translateX(-100px);
  transition: opacity 1s ease, transform 1s ease;
}

.slide-in-active {
  opacity: 1;
  transform: translateX(0);
}

.footer {
  background: #ECE3C4;
}

.copyright-text {
  color: #000;
  font-family: "Poppins", sans-serif;
  font-size: 9.142px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.footer-header {
  color: #000;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.footer-email {
  color: #000;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 18.285px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.get-in-touch {
  color: #000;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 27.427px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.footer-info {
  color: #000;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 13.06px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.play-now-btn {
  width: 164.562px;
  height: 41.794px;
  flex-shrink: 0;
  border-radius: 19.591px;
  background: #B10F0D;
  color: #FFF;
  text-align: center;
  font-family: "Permanent Marker", cursive;
  font-size: 19.591px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.game-zar-text {
  color: #000;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 11.754px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  line-height: normal;
}

.ready-play-text {
  color: #000;
  text-align: center;
  font-family: "Permanent Marker", cursive;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-size: 27.911px;
}

.about-us-container {
  position: relative;
  background-image: url("../../assets/mobile/1.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
  width: 100vw;
  height: 768px;
}

.about-us-header {
  font-family: "Permanent Marker", cursive;
  color: #020102;
  text-align: center;
  font-size: 26.5px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.about-us-text {
  color: #020102;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.our-games-text {
  color: #000;
  text-align: center;
  font-family: "Permanent Marker", cursive;
  line-height: normal;
  font-size: 26.5px;
  font-style: normal;
  font-weight: 400;
}

.game-container {
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100vw;
  height: 680px;
}

.game-header {
  font-family: "Permanent Marker", cursive;
  color: #FFF;
  font-size: 26.5px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.game-text {
  font-family: "Poppins", sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>